import { render, staticRenderFns } from "./HistoryView.vue?vue&type=template&id=78990ed5&scoped=true&"
import script from "./HistoryView.vue?vue&type=script&lang=js&"
export * from "./HistoryView.vue?vue&type=script&lang=js&"
import style0 from "./HistoryView.vue?vue&type=style&index=0&id=78990ed5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78990ed5",
  null
  
)

export default component.exports